// extracted by mini-css-extract-plugin
export default {"galleryContainer":"ImageGallery_galleryContainer__PV69G","button":"ImageGallery_button__-rb+Z"};